<template>
  <kst-table action paginated view-mode
    :data="items"
    :loading="isListLoading"
  >
    <b-table-column sortable
      v-slot="{ column, row }"
      field="Name"
      :label="Catalog.Name.Label"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column sortable
      v-slot="{ column, row }"
      field="Address"
      :label="Catalog.Address.Label"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column sortable
      v-slot="{ column, row }"
      field="PIC"
      :label="Catalog.PIC.Label"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column sortable
      v-slot="{ column, row }"
      field="NoPIC"
      :label="Catalog.NoPIC.Label"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column sortable
      v-slot="{ row }"
      cell-class="ks-col-status"
      field="IsActive"
      :label="Catalog.IsActive.Label"
    >
      <kst-status :value="row.IsActive" :statusEnum="Model.Status"/>
    </b-table-column>

    <template #action="{ row }">
      <Action :row="row"/>
    </template>
  </kst-table>
</template>

<script>
import Catalog from "../WarehouseCatalog.js";
import Model from "../WarehouseModel.js";

import Action from "./WarehouseList_Action";

export default {
  components: {
    Action
  },
  props: {
    items: Array,
    isListLoading: Boolean
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model
  })
}
</script>